import { Colors } from './colors';

// Global theme constants
export const colors = {
  primary: Colors.PRIMARY_DARK,
  white: Colors.WHITE,
  grey: '#808080',
  lightGrey: '#C4C4C4',
  success: Colors.SUCCESS_GREEN,
  warning: Colors.WARNING_ORANGE,
  cardBackground: Colors.CARD_BACKGROUND,
  neutral: Colors.NEUTRAL_GRAY,
  error: Colors.ERROR_RED
}

export const typography = {
  fontFamily: '"Roboto", sans-serif',
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fontSizes: {
    small: '0.875rem', // 14px
    medium: '0.9375rem', // 15px
    base: '1rem',
    h1: '3rem', // section titles
    h2: '1.75rem',
    h3: '1.25rem'// section subtitle
  }
}

